import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function StarActive({ height = 60, width = 60, ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="m11.0841 3.53622c.3747-.71472 1.4573-.71472 1.832 0l2.2988 4.38477c.1488.28355.4362.47975.7686.52539l5.1406.70313c.8378.1146 1.1726 1.08429.5664 1.64059l-3.7197 3.4131c-.2408.2209-.3508.5396-.294.8516l.878 4.8193c.1427.7852-.7323 1.384-1.4815 1.0137l-4.5976-2.2754c-.2976-.1473-.6536-.1473-.9512 0l-4.59766 2.2754c-.7492.3705-1.62508-.2285-1.48242-1.0137l.8789-4.8193c.05683-.3119-.05328-.6307-.29394-.8516l-3.71973-3.4131c-.60629-.5563-.27147-1.52598.56641-1.64059l5.13965-.70313c.33267-.0455.62071-.24164.76953-.52539z" fill="#fff" />
    </SVGWrapper>
  );
}

export { StarActive };
